// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3BTEZ","select":"Header_select__2j7fj","clinic":"Header_clinic__25EML"};